import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { CandidateAdapter } from '@shared/models';
import { PDFTooltipService } from '@shared/services/tooltip.service';

@Component({
  selector: 'mojo-pdf-preview-tooltip',
  templateUrl: './pdf-preview-tooltip.component.html',
  styleUrls: ['./pdf-preview-tooltip.component.scss'],
})
export class PdfPreviewTooltipComponent implements OnDestroy {
  @Input() candidate: CandidateAdapter;
  @Input() linkText = 'Resume';
  @Input() icon = true;
  @Input() fromNotes = false;
  @Input() iconEnlarge = false;

  @ViewChild('pdf') el: TemplateRef<any>;

  showInContainer: boolean;
  hoveringOverButton = false;
  hoveringOverMenu = false;
  top = '0px';
  left = '0px';
  displayPanel = false;
  private readonly pdfTooltipSize = 704;

  constructor(private tooltipService: PDFTooltipService, private cdr: ChangeDetectorRef) {}

  ngOnDestroy() {
    this.tooltipService.hidePdf();
    this.cdr.detectChanges();
  }

  handleMouseoverButton(e) {
    this.hoveringOverButton = true;
    this.displayPanel = true;
    const { clientX, clientY } = e;
    const { innerHeight, innerWidth } = window;
    // todo clean up
    if (clientY < innerHeight / 2) {
      if (this.fromNotes) {
        const move800Left = 800;
        this.left = clientX - move800Left + 'px';
        const move300Down = 300;
        this.top = clientY - move300Down + 'px';
      } else {
        const move40Right = 40;
        this.left = clientX + move40Right + 'px';
        const move200Down = 200;
        this.top = clientY - move200Down + 'px';
      }
    } else if (clientY > innerHeight / 2 && clientY < (innerHeight * 3) / 4) {
      if (this.fromNotes) {
        const move800Left = 800;
        this.left = clientX - move800Left + 'px';
        const move500Down = 500;
        this.top = clientY - move500Down + 'px';
      } else {
        const move40Right = 40;
        this.left = clientX + move40Right + 'px';
        const move500Down = 500;
        this.top = clientY - move500Down + 'px';
      }
    } else {
      if (this.fromNotes) {
        const move800Left = 800;
        this.left = clientX - move800Left + 'px';
        const move695Down = 695;
        this.top = clientY - move695Down + 'px';
      } else {
        const move40Right = 40;
        this.left = clientX + move40Right + 'px';
        const move695Down = 695;
        this.top = clientY - move695Down + 'px';
      }
    }

    if (clientX > innerWidth - this.pdfTooltipSize) {
      const move20Down = 20;
      this.left = innerWidth - this.pdfTooltipSize + 'px';
      this.top = Math.min(clientY + move20Down, innerHeight - this.pdfTooltipSize) + 'px';
    }

    this.tooltipService.showPdf(this.el);
    this.cdr.detectChanges();
  }

  handleMouseleaveButton() {
    this.hoveringOverButton = false;
    this.checkIfPanelShouldBeClosed();
  }

  handleMouseoverMenu() {
    this.hoveringOverMenu = true;
  }

  handleMouseleaveMenu() {
    this.hoveringOverMenu = false;
    this.checkIfPanelShouldBeClosed();
  }

  private checkIfPanelShouldBeClosed() {
    setTimeout(() => {
      if (!this.hoveringOverMenu && !this.hoveringOverButton) {
        this.tooltipService.hidePdf();
        this.cdr.detectChanges();
      }
    }, 100);
  }
}
